export const QUICK_CANCEL_CONFIRMED = 'QuickCancelConfirmed';
export const QUICK_CANCEL_BACKED_OUT = 'QuickCancelBackedOut';
export const QUICK_CANCEL_ELIGIBLE = 'QuickCancelEligible';
export const QUICK_CANCEL_NO_SUBSCRIPTION = 'QuickCancelNoSubscription';
export const QUICK_CANCEL_NOT_ELIGIBLE = 'QuickCancelNotEligible';
export const QUICK_CANCEL_CONFIRMATION_DISPLAYED =
  'QuickCancelConfirmationDisplayed';
export const QUICK_CANCEL_CONFIRMATION_END = 'QuickCancelConfirmationEnd';
